import { ContractInformation } from '../types'
import { getChainId } from './getChainId'

export const getContractReadInfo = ({ contractAddress, abi, chain }: ContractInformation) => {
  const chainToUseId = getChainId(chain)
  const contractInfo = {
    addressOrName: contractAddress,
    contractInterface: abi,
    chainId: chainToUseId
  }
  const contracts = [
    {
      ...contractInfo,
      functionName: 'saleDetails'
    }
  ]

  return contracts
}
